import React, { useState, useEffect } from 'react';
import PubSub from 'services/PubSub/';
import Modal from "components/Modal";
import Register from 'components/ModalRegister/Register';
import { actionsType } from 'config/constants';

let actions = [];

const ModalRegister = () => {
    const [dataModal, setDataModal] = useState(null);

    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.REGISTER_OPEN, registerOpen));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const registerOpen = (payload) => {
        
        setDataModal((payload && payload.value) ? payload.value : null);
    }

    const closeRegister = () => {
        setTimeout(()=> PubSub.dispatch(actionsType.MODAL.REGISTER_CLOSE),0);
    }

    return (
        
        <Modal customClass='modal-register' actionOpen={actionsType.MODAL.REGISTER_OPEN} actionClose={actionsType.MODAL.REGISTER_CLOSE}>
            <Register dataModal={dataModal} closeRegister={closeRegister} />
        </Modal>
        
    );
}

export default ModalRegister;
